import { UserManagerSettings, WebStorageStateStore } from 'oidc-client-ts';
import { readRuntimeConfig } from '../config/runtime-config';

const oidcAudience = readRuntimeConfig(
  'VITE_OIDC_AUDIENCE',
  import.meta.env.VITE_OIDC_AUDIENCE ?? 'control-plane',
);

export const oidcSettings: UserManagerSettings = {
  authority: readRuntimeConfig(
    'VITE_OIDC_AUTHORITY',
    import.meta.env.VITE_OIDC_AUTHORITY ?? 'http://localhost:8080/realms/nwm',
  ),
  client_id: readRuntimeConfig(
    'VITE_OIDC_CLIENT_ID',
    import.meta.env.VITE_OIDC_CLIENT_ID ?? 'admin-bff',
  ),
  redirect_uri: readRuntimeConfig(
    'VITE_OIDC_REDIRECT_URI',
    import.meta.env.VITE_OIDC_REDIRECT_URI ?? `${window.location.origin}/auth/callback`,
  ),
  post_logout_redirect_uri: readRuntimeConfig(
    'VITE_OIDC_POST_LOGOUT_REDIRECT_URI',
    import.meta.env.VITE_OIDC_POST_LOGOUT_REDIRECT_URI ?? `${window.location.origin}/auth/logged-out`,
  ),
  scope: readRuntimeConfig(
    'VITE_OIDC_SCOPE',
    import.meta.env.VITE_OIDC_SCOPE ?? 'openid profile email',
  ),
  response_type: 'code',

  extraQueryParams: {
    audience: oidcAudience,
  },

  userStore: new WebStorageStateStore({ store: window.sessionStorage }),
  automaticSilentRenew: true,
  loadUserInfo: true,
  filterProtocolClaims: true,
};
